import App from './App';
import { Providers } from './components/Providers';

export const Main = () => {
  return (
    <Providers>
      <App />
    </Providers>
  );
};
